/**
 * Склейка страницы сообщений с тем, что уже загружено в канале (стор social). Чистые функции,
 * их проверяет scripts/message-merge.test.mjs.
 */
import type { Message } from '@/types/api'

/** Сравнение snowflake как чисел произвольной длины. */
export function compareIds(a: string, b: string): number {
  if (a.length !== b.length) return a.length - b.length
  return a < b ? -1 : a > b ? 1 : 0
}

/** Своё, ещё не принятое сервером: отправляется или не отправилось. */
const local = (m: Message) => Boolean(m.pending || m.failed)

/** Последнее сообщение, которое уже есть на сервере; своё неотправленное не в счёт. */
export function lastConfirmed(list: Message[]): string | null {
  for (let i = list.length - 1; i >= 0; i--) if (!local(list[i]!)) return list[i]!.id
  return null
}

/**
 * Первая загрузка и «Перейти к новым»: страница заменяет загруженное. Остаются сообщения новее
 * страницы (пришли по шлюзу, пока она грузилась) и свои неотправленные.
 */
export function mergeInitial(page: Message[], existing: Message[]): Message[] {
  const pendingOnly = existing.filter(local)
  const ids = new Set(page.map((m) => m.id))
  const newer = existing.filter((m) => !local(m) && !ids.has(m.id) && page.length > 0 && compareIds(m.id, page[page.length - 1]!.id) > 0)
  return [...page, ...newer, ...pendingOnly]
}

/**
 * Конец истории после переподключения: события за перерыв сервер не досылает, их приносит страница.
 * since — последнее сообщение, до которого загруженное шло без пропусков. Страница до него
 * дотянулась — история выше неё остаётся, а в её пределах верна страница: удалённое пропадает,
 * правки и реакции обновляются. Не дотянулась (за перерыв пришло больше страницы) — как первая
 * загрузка. full — страница полная, и раньше неё есть ещё сообщения.
 */
export function mergeResync(page: Message[], existing: Message[], since: string | null, full: boolean): { list: Message[]; keptOlder: boolean } {
  const oldest = page[0]?.id
  if (!full || since === null || oldest === undefined || compareIds(since, oldest) < 0) return { list: mergeInitial(page, existing), keptOlder: false }
  const older = existing.filter((m) => !local(m) && compareIds(m.id, oldest) < 0)
  return { list: [...older, ...mergeInitial(page, existing)], keptOlder: older.length > 0 }
}
